import React from 'react'
import { Link } from 'react-router-dom'
import { PageBarFrame } from './PageBarFrame'
import { PageBarSubject } from './PageBarSubject'

interface Props {
  subject: React.ReactNode
  /** Route back to this record's list, rendered as an arrow rather than a crumb trail. */
  backTo?: string
  eyebrow?: React.ReactNode
  actions?: React.ReactNode
  /** Tabs for this record, on a second row under the bar. */
  tabs?: React.ReactNode
}

export const DetailPageBar = ({ subject, backTo, eyebrow, actions, tabs }: Props) => (
  <PageBarFrame below={tabs && <div className="flex w-full items-center gap-1 px-4">{tabs}</div>}>
    {backTo && (
      <Link
        to={backTo}
        aria-label="Back"
        className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg text-mm-neutral-1-600 transition-colors hover:bg-mm-neutral-1-100"
      >
        <i className="fad fa-arrow-left" aria-hidden />
      </Link>
    )}
    <PageBarSubject eyebrow={eyebrow}>{subject}</PageBarSubject>
    {actions && <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div>}
  </PageBarFrame>
)
